import type { IAdvertiser } from '@/Interfaces/Advertiser.interface';

type FilterFunction = (advertiser: IAdvertiser | null | undefined) => boolean;

export const footTrafficAdvertiserFilter: FilterFunction = advertiser => !!advertiser?.footTrafficLocations?.length;

export const beeswaxAdvertiserFilter: FilterFunction = advertiser => !!advertiser?.beeswaxAdvertiser?.beeswax_id;

export const youtubeAdvertiserFilter: FilterFunction = advertiser => !!advertiser?.hasDv360Partner;

export const activeAdvertiserFilter: FilterFunction = advertiser => !advertiser?.is_archived;
